import React from "react";
import UnplugIcon from "../../icons/unplug.icon";
import PlugInIcon from "../../icons/plug-in.icon";
import { integrations } from "./mock.data";
import styles from "./integrations-table.module.scss";
import { cn } from "../../../Utils/class-names.utils";
import { IntegrationActionsCell } from "./integration-actions-cell.component";

const IntegrationsTable = () => {
  return (
    <div className={styles.table}>
      <div className={styles.headerRow}>
        <div className={cn(styles.headerCell, styles.headerCellIntegration)}>
          <div className={styles.headerLabel}>Integration</div>
        </div>

        <div className={cn(styles.headerCell, styles.headerCellStatus)}>
          <div className={styles.headerLabel}>Status</div>
        </div>

        <div className={cn(styles.headerCell, styles.headerCellLastRun)}>
          <div className={styles.headerLabel}>Last Run</div>
        </div>

        <div className={cn(styles.headerCell, styles.headerCellNextRun)}>
          <div className={styles.headerLabel}>Next Run</div>
        </div>

        <div className={cn(styles.headerCell, styles.headerCellEmpty)} />
      </div>

      {integrations.map((integration, index) => (
        <div
          key={integration.id}
          className={styles.row}
        >
          <div className={styles.integrationCell}>
            <div className={styles.integrationCellInner}>
              <img
                className={styles.logo}
                alt={integration.name}
                src={integration.logo || "/images/attack-surface/generic2.svg"}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = "/images/attack-surface/generic2.svg";
                }}
              />

              <div className={styles.integrationName}>{integration.name}</div>
            </div>
          </div>

          <div className={styles.statusCell}>
            <div className={styles.statusCellInner}>
              <div
                className={cn(styles.statusBadge, {
                  [styles.statusBadgeError]: integration.status === "error",
                  [styles.statusBadgeSynced]: integration.status === "synced",
                })}
              >
                <div className={styles.statusIconWrapper}>
                  {integration.status === "error" ? (
                    <UnplugIcon className={styles.statusIcon} />
                  ) : (
                    <PlugInIcon className={styles.statusIcon} />
                  )}
                </div>

                <div className={styles.statusTextWrapper}>
                  <div
                    className={cn({
                      [styles.statusTextError]: integration.status === "error",
                      [styles.statusTextSynced]: integration.status === "synced",
                    })}
                  >
                    {integration.status === "error" ? "Error" : "Synced"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.lastRunCell}>
            <div className={styles.lastRunCellInner}>
              <div className={styles.runTextWrapper}>
                <div className={styles.runText}>{integration.lastRun}</div>
              </div>
            </div>
          </div>

          <div className={styles.nextRunCell}>
            {integration.nextRun ? (
              <div className={styles.nextRunCellInner}>
                <div className={styles.runTextWrapper}>
                  <div className={styles.runText}>{integration.nextRun}</div>
                </div>
              </div>
            ) : (
              <div className={styles.nextRunPlaceholder} />
            )}
          </div>

          <IntegrationActionsCell integrationId={integration.id} />
        </div>
      ))}
    </div>
  );
};

export default IntegrationsTable;
